import { ReactNode } from "react";

import { Box, useBreakpointValue } from "@/storybook-components";
import StickyActionBar from "./sticky-action-bar";

function ContentArea({
  mainContent,
  actions,
  onClose,
  isOpen,
  splitActions
}: {
  mainContent: ReactNode;
  actions?: { component: ReactNode; position: "left" | "right" }[];
  onClose?: () => void;
  isOpen?: boolean;
  splitActions?: boolean;
}) {
  const isMobile = useBreakpointValue({ base: true, lg: false }) || false;

  return (
    <Box
      px={{ base: 4, lg: 8 }}
      py={{ base: 4, lg: 0 }}
      bg="gray.50"
      position="relative"
      display="flex"
      flexDirection="column"
      width="100%"
      flex={1}
    >
      {isMobile ? (
        <>
          <Box flex="1" mb={4}>
            {mainContent}
          </Box>

          <Box position="sticky" bottom={0} zIndex={10}>
            <StickyActionBar
              actions={actions}
              isOpen={isOpen}
              onClose={onClose}
              splitActions={splitActions}
            />
          </Box>
        </>
      ) : (
        <>
          <Box position="sticky" top={0} zIndex={10}>
            <StickyActionBar
              actions={actions}
              isOpen={isOpen}
              onClose={onClose}
              splitActions={splitActions}
            />
          </Box>

          <Box flex="1">{mainContent}</Box>
        </>
      )}
    </Box>
  );
}

export default ContentArea;
